import type { Channels } from '@eureka/shared/login-sdk';
import { loginSDK, SDK_ENV } from '@eureka/shared/login-sdk';
import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';
import type { I18n } from 'vue-i18n';

import { useVisitorCookies } from './home/use-visitor-cookies';
const { init } = useVisitorCookies();

export function useLoginSdk(i18n: I18n, channels: Channels = {}) {
  const sdkEnv = [DeployEnv.US, DeployEnv.EU].includes(REGION) ? SDK_ENV.US : SDK_ENV.CN;
  loginSDK.setI18n(i18n).setEnv(sdkEnv).setChannels(channels);
  loginSDK.handleThirdPartyLoginErrors();

  const openLoginDialog = (silence?: boolean) => {
    loginSDK
      .open({
        silence,
        withoutClose: true,
      })
      .then(async () => {
        window.location.reload();
        init();
      });
  };

  return { openLoginDialog };
}
